import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';
import { MyTonesCardCSSStyleImpl } from './mytonescardcss';

export class MyTonesEvenCardCSSStyleImpl extends MyTonesCardCSSStyleImpl {
    getWrapperCSSStyle(): object {
        return {
            width: '262px',
            height: 'auto',
            position: 'relative',
            borderRadius: '8px 50px 8px 8px',
            boxShadow: '0 2px 10px 0 rgba(0,0,0,0.07)',
            backgroundColor: this.getResources().getColor(Colors.color_5),
            marginBottom: "25px"
        };
    }


    getDefaultStatusCSSStyle(): object {
        return {
            width: "128px", height: "48px", top: "170px", textAlign: "center", right: "265.9px", position: "relative", zIndex: 1000
        };
    }
    getDefaultLabelCSSStyle(): object {
        return {
            width: "100%", position: "absolute", top: "10px", left: "-10px", zIndex: 1001, height: "100%", lineHeight: "27px", color: "#000000", fontSize: "20px", fontWeight: "bold",
        };
    }
    getToneDetailDivCSSStyle(): object {
        return {
        };
    }

    getRoundProfileImageDivCSSStyle(): object {
        return {
            width: '100%', height: '280px', display: 'flex', borderRadius: '50px 0px 50px 0px'
        };
    }

    getToneDivCSSStyle(): object {
        return {
            width: '100%', marginTop: '5px', marginLeft: '15px', height: '40px', position: 'relative', display: 'flex'
        };
    }

    getToneNameLabelCSSStyle(): object {
        return {
            width: '100%',
            height: '22px',
            lineHeight: '22px',
            fontWeight: '500',

            fontSize: this.getResources().getFont(Fonts.h8),
            fontFamily: this.getResources().getFontFamily(),
            color: this.getResources().getColor(Colors.color_6),
            letterSpacing: '0',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };
    }

    getArtistNameLabelCSSStyle(): object {
        return {
            width: '100%',
            fontWeight: '300',
            height: '17px',
            lineHeight: '17px', fontSize: this.getResources().getFont(Fonts.h6),
            color: this.getResources().getColor(Colors.color_7),
            fontFamily: this.getResources().getFontFamily(),
            letterSpacing: '0',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };
    }

    getRowHeaderDivCSSStyle(): object {
        return {
            width: '100%',
            height: '20px',
            lineHeight: '20px',
            fontWeight: '300',

            margin: '0px 15px 0px 15px',
            color: this.getResources().getColor(Colors.color_7),
            fontSize: this.getResources().getFont(Fonts.h6),
            fontFamily: this.getResources().getFontFamily(),

            display: 'flex'
        };
    }
    getRepeatLabelCSSStyle(): object {
        return {
            width: '20%',
            height: '20px',
            textAlign: 'left'
        };
    }

    getRowContentDivCSSStyle(): object {
        return {
            width: '100%',
            height: '20px',
            margin: '0px 15px 10px 15px',
            fontWeight: '500',

            lineHeight: '20px',
            color: this.getResources().getColor(Colors.color_6),
            fontSize: this.getResources().getFont(Fonts.h7),
            display: 'flex'
        };
    }
    getRowLabel1CSSStyle(): object {
        return {
            height: '100%',
            width: '24%',
            textAlign: 'left'
        };
    }

    getRowLabel2CSSStyle(): object {
        return {
            height: '100%',
            width: '40%',
            textAlign: 'left',
            letterSpacing: '0',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };
    }

    getRowLabel3CSSStyle(): object {
        return {
            height: '100%',
            width: '35%',
            textAlign: 'left'
        };
    }

    getBarDivCSSStyle(): object {
        return {
            width: '90%',
            height: '1px',
            margin: '10px 15px 10px 15px',
            backgroundColor: this.getResources().getColor(Colors.color_17)
        };
    }

    getFromDateLabelCSSStyle(): object {
        return {
            height: '100%',
            width: '50%',
            textAlign: 'left'
        };
    }

    getToDateLabelCSSStyle(): object {
        return {
            height: '100%',
            width: '50%',
            textAlign: 'left'
        };
    }
    getDeleteButtonCSSStyle(): object {
        return {
            width: '30px',
            height: '30px',
            alignItems: 'right',
            cursor: "pointer",
            marginRight: '20px',
            marginTop: '5px',
            marginLeft: 'auto'
        };
    }

    getRepeatDivCSSStyle(): object {
        return {
            width: '100%', height: '40px', display: 'flex',
            fontWeight: '300',

            marginTop: '5px', marginLeft: '15px',
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/listtone/viewmodel/mytonescard/mytonesevencardcss.tsx